var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-item-click-indicator"},[(_vm.clickIcon !== '')?_c(_vm.clickIcon,{tag:"component",attrs:{"size":20}}):_vm._e(),(_vm.clickIcon === '')?_c('icon-forward',{attrs:{"size":20}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }